/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CountryListResponse } from '../models';
// @ts-ignore
import type { CountryValidationRulesResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
/**
 * ValidationsApi - axios parameter creator
 * @export
 */
export const ValidationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns detailed validation rules for the specified country
         * @summary Get validation rules for a specific country
         * @param {string} countryCode ISO 3166-1 alpha-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryValidationRules: async (countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getCountryValidationRules', 'countryCode', countryCode)
            const localVarPath = `/api/v1/validations/supported-countries/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of all supported countries for validation purposes
         * @summary Get list of supported countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportedCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/validations/supported-countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationsApi - functional programming interface
 * @export
 */
export const ValidationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns detailed validation rules for the specified country
         * @summary Get validation rules for a specific country
         * @param {string} countryCode ISO 3166-1 alpha-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryValidationRules(countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryValidationRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryValidationRules(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationsApi.getCountryValidationRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns list of all supported countries for validation purposes
         * @summary Get list of supported countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportedCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportedCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationsApi.listSupportedCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidationsApi - factory interface
 * @export
 */
export const ValidationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationsApiFp(configuration)
    return {
        /**
         * Returns detailed validation rules for the specified country
         * @summary Get validation rules for a specific country
         * @param {string} countryCode ISO 3166-1 alpha-2 country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryValidationRules(countryCode: string, options?: RawAxiosRequestConfig): AxiosPromise<CountryValidationRulesResponse> {
            return localVarFp.getCountryValidationRules(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of all supported countries for validation purposes
         * @summary Get list of supported countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportedCountries(options?: RawAxiosRequestConfig): AxiosPromise<CountryListResponse> {
            return localVarFp.listSupportedCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationsApi - object-oriented interface
 * @export
 * @class ValidationsApi
 * @extends {BaseAPI}
 */
export class ValidationsApi extends BaseAPI {
    /**
     * Returns detailed validation rules for the specified country
     * @summary Get validation rules for a specific country
     * @param {string} countryCode ISO 3166-1 alpha-2 country code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationsApi
     */
    public getCountryValidationRules(countryCode: string, options?: RawAxiosRequestConfig) {
        return ValidationsApiFp(this.configuration).getCountryValidationRules(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of all supported countries for validation purposes
     * @summary Get list of supported countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationsApi
     */
    public listSupportedCountries(options?: RawAxiosRequestConfig) {
        return ValidationsApiFp(this.configuration).listSupportedCountries(options).then((request) => request(this.axios, this.basePath));
    }
}

